import { Injectable } from '@angular/core';
import { Shipment } from '@features/shared-features/models/shipment.model';
import { enumToArray } from '@shared/utils/enum-to-array.util';
import { RoutesUtil } from '@shared-features/utils/routes.util';
import { ShipmentCreationTemplateTypes } from '@shared-features/enums/shipments.enum';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTemplateService {
  private RoutesPerTemplate = {
    [ShipmentCreationTemplateTypes.Basic]: {
      add: RoutesUtil.ShipmentTemplateBasicAdd,
      edit: RoutesUtil.ShipmentTemplateBasicEdit,
    },

    [ShipmentCreationTemplateTypes.Bidding]: {
      add: RoutesUtil.ShipmentTemplateBasicAdd,
      edit: RoutesUtil.ShipmentTemplateBasicEdit,
    },

    [ShipmentCreationTemplateTypes.Cement]: {
      add: RoutesUtil.ShipmentTemplateCementAdd,
      edit: RoutesUtil.ShipmentTemplateCementEdit,
    },
    [ShipmentCreationTemplateTypes.Orders]: {
      add: RoutesUtil.ShipmentTemplateOrdersAdd,
      edit: null,
    },
  };

  private templates = enumToArray(ShipmentCreationTemplateTypes);
  private isTemplateAvailable(template: ShipmentCreationTemplateTypes): boolean {
    if (!template) {
      return false;
    }

    return !!this.templates.find((t) => t.value === template);
  }

  constructor() {}

  getEditUrl(shipment: Shipment): string {
    const { shipmentCreationTemplate, customer } = shipment;
    const customerDefaultTemplate = ((customer as any)?.templates || []).find((t) => t.isDefault);

    if (shipmentCreationTemplate && this.isTemplateAvailable(shipmentCreationTemplate)) {
      const route = this.RoutesPerTemplate[shipmentCreationTemplate];
      return route.edit?.url({ id: shipment.id });
    } else if (customerDefaultTemplate && this.isTemplateAvailable(customerDefaultTemplate.type)) {
      const route = this.RoutesPerTemplate[customerDefaultTemplate.type];
      return route.edit?.url({ id: shipment.id });
    } else {
      const route = this.RoutesPerTemplate[ShipmentCreationTemplateTypes.Basic];
      return route.edit?.url({ id: shipment.id });
    }
  }

  getCreateUrl(template?: (typeof ShipmentCreationTemplateTypes)[keyof typeof ShipmentCreationTemplateTypes], queryParams?: any): string {
    if (!template || !this.isTemplateAvailable(template)) {      
      return this.RoutesPerTemplate[ShipmentCreationTemplateTypes.Basic].add.url(undefined, queryParams || {});
    }


    return this.RoutesPerTemplate[template].add.url(undefined, queryParams || {});
  }
}
